import React from 'react';
import { string } from 'prop-types';

import { ReactComponent as Warning } from '~assets/ic_error_warning.svg';

import styles from './styles.module.scss';

function AddressWarningBanner({ description }) {
  return (
    <div className={styles.container}>
      <Warning className={styles.warningIcon} />
      <div className={styles.innerContainer}>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

AddressWarningBanner.propTypes = {
  description: string
};

export default AddressWarningBanner;
